/**
 * Whether this tab already answered "continue or start over" since the last sign-in. Kept in the tab's own storage, so
 * a reload does not ask again and a new visit does. Signing out forgets it, so the next sign-in asks.
 */
const RESUME_DECISION_KEY = 'onboarding:resume-decided';

export function hasResumeDecision(storage: Storage | null): boolean {
  try {
    return storage?.getItem(RESUME_DECISION_KEY) === '1';
  } catch {
    return false;
  }
}

export function recordResumeDecision(storage: Storage | null): void {
  try {
    storage?.setItem(RESUME_DECISION_KEY, '1');
  } catch {
    // The worst case is asking again after a reload.
  }
}

export function forgetResumeDecision(storage: Storage | null): void {
  try {
    storage?.removeItem(RESUME_DECISION_KEY);
  } catch {
    // Nothing to forget if storage is unusable.
  }
}
